// This is for caching the blob urls
export const existingImageUrls = new Map();
//# sourceMappingURL=image.util.js.map